import { StyleSheet, View } from 'react-native';
import { Modal, Portal } from 'react-native-paper';

import { i18n } from '@/utils/i18n';

import BrandedButton from '../buttons/BrandedButton';
import CloseButton from '../buttons/CloseButton';
import Text from '../Text';

export type ConfirmWarningModalProps = {
  message?: string;
  confirmLabel?: string;
  showPicker: boolean;
  loading: boolean;
  onClosePicker: () => void;
  onConfirmTapped: () => void;
};

const ConfirmWarningModal = ({
  message = i18n.t('mix.delete_warning'),
  confirmLabel = i18n.t('mix.delete'),
  showPicker,
  loading,
  onClosePicker,
  onConfirmTapped
}: ConfirmWarningModalProps) => {
  return (
    <Portal>
      <Modal visible={showPicker} onDismiss={onClosePicker} contentContainerStyle={style.modalContent}>
        <View>
          <CloseButton style={style.closeBtn} onCloseTap={onClosePicker} />
          <View style={style.content}>
            <Text fontWeight="900" style={style.message}>
              {message}
            </Text>

            <View style={style.optionsContainer}>
              <BrandedButton style={style.flexOne} onPress={onClosePicker}>
                {i18n.t('mix.close')}
              </BrandedButton>

              <BrandedButton
                style={style.flexOne}
                loading={loading}
                backGroundColor="#B41C1C"
                onPress={onConfirmTapped}>
                {confirmLabel}
              </BrandedButton>
            </View>
          </View>
        </View>
      </Modal>
    </Portal>
  );
};

const style = StyleSheet.create({
  flexOne: {
    flex: 1
  },

  modalContent: {
    backgroundColor: 'white',
    marginHorizontal: 'auto',
    alignItems: 'center',
    padding: 10,
    borderRadius: 23
  },

  content: {
    flexDirection: 'column',
    gap: 25,
    padding: 20
  },

  optionsContainer: {
    flexDirection: 'row',
    width: '100%',
    gap: 15
  },

  message: {
    flex: 1,
    flexWrap: 'wrap',
    fontSize: 22,
    color: 'black',
    justifyContent: 'center',
    alignSelf: 'center',
    textAlign: 'center'
  },

  closeBtn: {
    alignItems: 'flex-start'
  }
});

export default ConfirmWarningModal;
